export default __webpack_public_path__ + "static/benthyg-17837e0264c72d7e03524fac94560a2b.png";